module.exports = __webpack_public_path__ + "assets/SF-on-lottery-jiang-1de8c048.png";